import { useContext } from 'react';
import { LoginDialogContext } from '../header/login/LoginDialogContext';
import { ProductoData } from '../../model/ProductoData';
import { OpenCanjeFn } from './useCanjeActivation';

/** Hook que controla si la sesión del usuario sigue
 *  vigente (no vencida). En caso de que esté vencida,
 *  cierra el modal de canje y abre el modal de login.
 *  Además, se pasa un callback al modal de login para
 *  que se vuelva a abrir el modal de canje en caso de
 *  login exitoso. */
export function useCheckSession(
  checkLogin: () => boolean,
  reset: () => void,
  product?: ProductoData,
  reopenCanje?: OpenCanjeFn,
  closeCanjeDialog?: () => void
) {
  const loginDialogState = useContext(LoginDialogContext);

  const check = () => {
    const checkLoginStatus = checkLogin();
    if (!checkLoginStatus) {
      loginDialogState?.showDialog((loginData) => {
        reopenCanje?.(loginData, product);
      });
      closeCanjeDialog?.();
      reset();
    }
    return checkLoginStatus;
  };
  return check;
}
